module.exports = __webpack_public_path__ + "static/img/tiggy_pictgrid25_1020x861.0bca1ec.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/tiggy_pictgrid25_1020x861.jpg
// module id = UMAc
// module chunks = 0